import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useCarLeasingApi } from "../../http/carLeasings/api";
import { formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";
import Textarea from "../ui/Textarea";
import VersionDialog from "../ui/VersionDialog";

type CarLeasingHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const CarLeasingHistoryDialog: FC<CarLeasingHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();

  const carLeasingApi = useCarLeasingApi();

  return (
    <HistoryDialog
      title={i18n.t.carLeasings.versions}
      entityId={itemToShowVersionsId}
      lastVersion={itemVersionToShowVersions}
      getEntityVersionHook={carLeasingApi.getAdminCarLeasingVersion}
      getHistory={carLeasingApi.getAdminCarLeasingHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <VersionDialog.Table headers={headers}>
          {(dataVersion.current?.leasingCompany?.id ?? null) !== (dataVersion.next.leasingCompany?.id ?? null) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.leasingCompanies.singular}
                value={dataVersion.current?.leasingCompany?.name}
                edited={dataVersion.next.leasingCompany?.name}
              />
            </tr>
          )}
          {dataVersion.current?.contractDate != dataVersion.next.contractDate && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.contractDate}
                value={dataVersion.current && formatDate(dataVersion.current?.contractDate!, i18n.language)}
                edited={formatDate(dataVersion.next.contractDate, i18n.language)}
              />
            </tr>
          )}
          {dataVersion.current?.expirationDate != dataVersion.next.expirationDate && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.expirationDate}
                value={dataVersion.current && formatDate(dataVersion.current?.expirationDate!, i18n.language)}
                edited={formatDate(dataVersion.next.expirationDate, i18n.language)}
              />
            </tr>
          )}
          {(!dataVersion.current || dataVersion.current?.contractDetails != dataVersion.next.contractDetails) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.contractDetails}
                value={
                  <Textarea
                    value={
                      dataVersion.current && !dataVersion.current.contractDetails
                        ? ""
                        : dataVersion.current?.contractDetails
                    }
                    disabled
                  />
                }
                edited={<Textarea value={dataVersion.next.contractDetails} disabled />}
              />
            </tr>
          )}
        </VersionDialog.Table>
      )}
    />
  );
};

export default CarLeasingHistoryDialog;
